<template>
    <section>
        <h1 class="mb-0 mt-5 mb-3 text-center">{{$t('teams.header')}}</h1>

        <v-row>
            <v-col>
                <v-text-field
                        v-model="keyword"
                        :label="$t('global.search')"
                        hide-details
                >
                    <template v-slot:prepend-inner>
                        <svg v-svg="'icon-search'" size="15"></svg>
                    </template>
                </v-text-field>
            </v-col>
        </v-row>

        <v-data-table :headers="headers"
                      :items="TEAMS"
                      hide-default-footer
                      class="elevation-1 mt-13 mb-6"
                      mobile-breakpoint="0"
        >
            <template v-slot:item.id="props">
                {{props.index+1}}
            </template>

            <template v-slot:item.actions="props">
                <v-btn text class="px-0 members" :to="{name: 'Students', query: {team_id: props.item.id}}">
                    <svg v-svg="'icon-members'" size="12" fill="currentColor" class="mr-1"></svg>
                    <span>{{$t('teams.members')}}</span>
                </v-btn>

                <v-btn text class="px-0 ml-3" @click="[$refs.settings.dialog = true, selectedTeam = props.item.id]">
                    <svg v-svg="'icon-settings'" size="12" class="mr-1"></svg>
                    <span class="settings">{{$t('teams.settings')}}</span>
                </v-btn>
            </template>

            <template v-slot:header.actions class="d-none"></template>
        </v-data-table>

        <settings ref="settings" :team_id="selectedTeam"></settings>
    </section>
</template>

<script>
    import {mapGetters} from 'vuex';
    import Settings from '@/components/Teams/Settings';
    export default {
        components: { Settings },
        data(){
            return {
                timeout: null,
                loadingRequest: false,
                selectedTeam: null,
                keyword: null,
                headers: [
                    {text: '#ID', sortable: false, value: 'id'},
                    {text: this.$t('teams.name'), sortable: false, value: 'name'},
                    {text: this.$t('teams.members'), sortable: false, value: 'users_count', align: 'center'},
                    {text: 'Actions', sortable: false, value: 'actions', align: 'right'}
                ],
            }
        },

        computed: mapGetters(['TEAMS']),

        mounted(){
            this.getData();
        },

        watch: {
            keyword() {
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.getData();
                }, 300);
            }
        },

        methods: {
            getData(){
                this.loadingRequest = true;
                this.$store.dispatch('GET_TEAMS', {params: {keyword: this.keyword}})
                    .then(() => this.loadingRequest = false);
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../scss/pages/tablePages";
    @import "../../scss/pages/Teams/index";
</style>